import type { FC, PropsWithChildren } from 'react';
import { Container, type ContainerProps } from '@mui/material';

export type PageContentProps = PropsWithChildren<ContainerProps>;

export const PageContent: FC<PageContentProps> = ({ children, ...props }) => (
  <Container maxWidth="xl" sx={{ display: 'flex', flex: 1, py: 2 }} {...props}>
    {children}
  </Container>
);
